import { createSlice } from "@reduxjs/toolkit";

const JewellerReportSlice = createSlice({
  name: "jewellerReport",
  initialState: {
    loading: false,
    data: null,
    message: "",
    error: null,
  },
  reducers: {
    fetchJewellerReportRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    fetchJewellerReportSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload.report;
      state.message = action.payload.message;
    },
    fetchJewellerReportFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchJewellerReportRequest,
  fetchJewellerReportSuccess,
  fetchJewellerReportFailure,
} = JewellerReportSlice.actions;

export default JewellerReportSlice.reducer;
